import { Station } from './station.model';
import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Container class for station group information
 *
 * @export
 * @class StationGroup
 */
@JsonObject()
export class StationGroup {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('Description') description: string;
  @JsonProperty({ name: 'Members', type: Station }) members: Array<Station>;
}
